var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"au-upload",attrs:{"drag":"","multiple":_vm.multiple,"action":"","auto-upload":false,"show-file-list":false,"accept":_vm.accept,"on-change":_vm.onChange}},[_c('i',{staticClass:"el-icon-upload"}),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击导入")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }